import { useState, useEffect } from "react";
import { projectAuth } from "../firebase/config";
import { useAuthContext } from "./useAuthContext";
import { projectFirestore } from "../firebase/config";

export const useSignup = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();

  function includesNumber(str) {
    return /\d/.test(str);
  }

  const signup = async (email, password, displayName) => {
    setError(null);
    setIsPending(true);

    try {
      // signup
      const res = await projectAuth.createUserWithEmailAndPassword(
        email,
        password
      );

      if (!res) {
        throw new Error("Could not complete signup");
      }

      // add display name to user
      await res.user.updateProfile({ displayName });


      if (includesNumber(res.user.email)) {
        const userRef = projectFirestore
          .collection("students")
          .doc(res.user.uid);
        const userData = {
          email: res.user.email,
          student_id: res.user.email.match(/\d+/)[0],
          form_link: "",
          name: "",
          status: "Pending",
          new_subjects: [],
        };

        // set user data in database
        await userRef.set(userData);
      } else {
        const userRef = projectFirestore
          .collection("supervisors")
          .doc(res.user.uid);

        const userData = {
          email: res.user.email,
          students: [],
          name: "",
        };

        await userRef.set(userData);
      }

      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }
    } catch (err) {
      if (!isCancelled) {
        setError(err.message);
        setIsPending(false);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { signup, error, isPending };
};
